import { render } from "./TheStickyFooterButton.vue?vue&type=template&id=42ee9eb2&scoped=true"
const script = {}

import "./TheStickyFooterButton.vue?vue&type=style&index=0&id=42ee9eb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ee9eb2"]])

export default __exports__